module.exports = __webpack_public_path__ + "static/mo43-20b82565030419e715ceccb94e6c2750.png";